import { useLanguage } from "@/context/LanguageContext";
import { faqContent } from "@/i18n/faqContent";
import { mediaUrl } from "@/lib/mediaUrl";

const Footer = () => {
  const { t, lang } = useLanguage();

  const links = [
    { href: "#build", label: t.nav.build, id: "footer-nav-build" },
    { href: "#work", label: t.nav.work, id: "footer-nav-work" },
    { href: "#saas-explainers", label: t.nav.explainers, id: "footer-nav-explainers" },
    { href: "#resources", label: t.nav.resources, id: "footer-nav-resources" },
    { href: "#faq", label: faqContent[lang].eyebrow, id: "footer-nav-faq" },
    { href: "#contact", label: t.nav.cta, id: "footer-nav-contact" },
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-line bg-softwhite">
      <div className="mx-auto max-w-7xl px-5 py-12 md:px-8">
        <div className="flex flex-col items-center justify-between gap-8 md:flex-row">
          <a href="#top" data-testid="footer-logo-link" aria-label="YacoubCreates">
        <img src={mediaUrl("/brand/logo-primary.png")} alt="YacoubCreates" className="h-6 w-auto" width="374" height="93" />
          </a>
          <nav className="flex flex-wrap items-center justify-center gap-6" aria-label="Footer">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={link.id}
                className="text-sm font-medium text-graphite/65 transition-colors duration-200 hover:text-charcoal"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <p className="font-display text-sm font-semibold text-sage-deep">{t.footer.tagline}</p>
        </div>
        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-line pt-6 text-xs text-graphite/50 md:flex-row">
          <span data-testid="footer-rights">{t.footer.rights}</span>
          <span dir="ltr" className="font-medium">
            {t.brand.domain}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
